import { useEffect } from 'react'
import Store from 'redux/Store'
import { getAllCustomData } from 'shared/components/App/Auth'
import { setCustomData } from 'shared/redux/actions'
import processCustomerChange from '../utils/processCustomerChange'
import { setCustomerName } from 'redux/actions'

interface useInitCentersProps {
  currentCustomer: any
  initialRender: boolean
  dataLoaded: boolean
  setInitialRender: Function
  handleCustomerChanged?: Function
}

const useCustomerChange = (props: useInitCentersProps) => {
  useEffect(() => {
    if (!props.initialRender && props.dataLoaded) {
      processCustomerChange({
        customer_id: props.currentCustomer?.id,
        setShowOverlay: (data) => {},
      }).then((data: any) => {
        let allCustomData = getAllCustomData()
        allCustomData.customer = props.currentCustomer
        Store.dispatch(setCustomData(allCustomData))
        Store.dispatch(setCustomerName(allCustomData.customer.name))

        if (props.handleCustomerChanged !== undefined) {
          props.handleCustomerChanged(props.currentCustomer)
        }

        Store.dispatch(setCustomerName(props.currentCustomer.name))
      })
    } else {
      props.setInitialRender(false)
    }
  }, [props.currentCustomer])
}

export default useCustomerChange
